import { Box } from '@mui/material'
import { PageHeader } from '../components/shared/PageHeader'
import { LeadFormResponses } from '../features/leadforms/LeadFormResponses'

export default function LeadFormResponsesPage() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <PageHeader
        title="Form Responses"
        showBreadcrumb
        breadcrumb={[{ label: 'Lead Forms', to: '/custom-forms' }]}
      />
      <LeadFormResponses />
    </Box>
  )
}
